import React from 'react'
import { getBuyNowInPDP } from 'config/appConfig'
import { ExpressPDP } from '../ExpressPDP'
import { Product } from '../Product'

class DynamicPDP extends React.Component {
  render() {
    return (
      <>
        {getBuyNowInPDP() ? (
          <ExpressPDP {...this.props} />
        ) : (
          <Product {...this.props} />
        )}
      </>
    )
  }
}

export default DynamicPDP
export { DynamicPDP }
